module.exports = __webpack_public_path__ + "img/delete_icon_hover.57f5bff9.svg";